import { userAtom } from '@/atoms/user.atom';
import { DangerZone } from '@/components/account/DangerZone';
import { LoginSessions } from '@/components/account/LoginSessions';
import { PasskeySettings } from '@/components/account/PasskeySettings';
import { ProfileInformation } from '@/components/account/ProfileInformation';
import { SecuritySettings } from '@/components/account/SecuritySettings';
import { ViewerSettings } from '@/components/account/ViewerSettings';
import { execute } from '@/graphql/execute';
import { meQuery } from '@/queries/me.query';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { Loader2 } from 'lucide-react';
import { FunctionComponent, useEffect } from 'react';

const AccountPage: FunctionComponent = () => {
  const [, setUser] = useAtom(userAtom);
  const { data, isLoading, error } = useQuery({
    queryKey: [meQuery],
    queryFn: () => execute(meQuery),
  });

  // Update user atom when data is loaded
  useEffect(() => {
    if (data?.me) {
      setUser(data.me);
    }
  }, [data?.me, setUser]);

  if (isLoading) {
    return (
      <div className='flex items-center justify-center h-64'>
        <Loader2 className='h-8 w-8 animate-spin' />
      </div>
    );
  }

  if (error || !data?.me) {
    return (
      <div className='flex items-center justify-center h-64'>
        <div className='text-center'>
          <h2 className='text-lg font-semibold text-gray-900'>Error loading account</h2>
          <p className='text-gray-600'>Unable to load your account information.</p>
        </div>
      </div>
    );
  }

  const user = data.me;

  return (
    <div className='max-w-4xl px-4 pt-4 pb-12 mx-auto flex flex-col gap-4'>
      <ProfileInformation user={user} />
      <SecuritySettings userId={user.id} />
      <PasskeySettings />
      <ViewerSettings userId={user.id} />
      <DangerZone userId={user.id} />
      <LoginSessions userId={user.id} />
    </div>
  );
};

export default AccountPage;
